export default {
    // NOTICE, the selectCommunicationScenario(scenario) must be implemented in the component you are using this mixin in

    data () {
        return {
            communication_channel_types: [],
            communication_channel_roles: [],
            selectedCommunicationScenario: null,
            defaultCommunication: {},
            preSelectedScenarioName: null,

            type_email: "email",
            type_sms: "sms",
            type_messenger: "messenger",

            role_tenant: "tenant",
            role_landlord: "landlord",
            role_service_provider: "service provider",
        };
    },

    watch: {
        communicationScenarios (newList) {
            if (newList && newList.length > 0) {
                let index = newList.findIndex(scenario => scenario.is_system == true && (this.preSelectedScenarioName ? scenario.name.toLowerCase() === this.preSelectedScenarioName : true));
                if (index !== -1) {
                    this.selectCommunicationScenario(newList[index]);
                }
            }
        },
    },

    mounted () {
        this.communication_channel_types = [this.type_email, this.type_sms];
        if (this.hasFeature("feat_service_provider_portals")) {
            this.communication_channel_types.push(this.type_messenger);
        }
        this.communication_channel_roles = [this.role_tenant, this.role_landlord, this.role_service_provider];
    },

    methods: {
        getCommunicationScenarios (scenarios) {
            return new Promise((resolve, reject) => {
                if (this.communicationScenarios && this.communicationScenarios.length > 0) {
                    resolve();
                }

                axios.get("/communication-scenarios/search", {
                    params: {
                        scenario: scenarios,
                    }
                })
                .then(response => {
                    this.communicationScenarios = response.data;
                    resolve();
                })
                .catch(error => {
                        toastr.error(error.message);
                        reject();
                    }
                );
            });
        },

        // get available saved replies from this.scenario
        getSavedReplies (scenario) {
            let result = {};
            this.communication_channel_roles.forEach(role => {
                this.communication_channel_types.forEach(type => {
                    if (type === "messenger" && role !== "service provider") {
                        return;
                    }
                    // tenant_email or service_provider_messenger
                    let key = _.snakeCase(role) + "_" + type;
                    result[key] = this.findSavedReply(scenario.saved_replies, role, type, scenario.category);
                });
            });
            return result;
        },

        findSavedReply (savedReplies, role, type, category = null) {
            return _.cloneDeep(savedReplies.find((savedReply) => savedReply.role.toLowerCase() === role && savedReply.type.toLowerCase() === type && (category ? savedReply.category.toLowerCase() === category : true)));
        },
    },
};